import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Spirit } from '../../../../core/models/spirit.model';
import { ApiService } from '../../../../core/services/api.service';
import { LockerSpirit } from '../../../../core/models/lockerSpirit.model';
import { MatDialog } from '@angular/material/dialog';
import { LockerIcon } from '../../../../shared/icons/locker/locker.component';
import { ChevronDownIcon } from '../../../../shared/icons/chevron-down/chevron-down.component';
import { SpiritDetailLockerConsumptionHistoryComponent } from './spirit-detail-locker-consumption-history/spirit-detail-locker-consumption-history.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpiritDetailLockerConsumptionComponent } from './spirit-detail-locker-consumption/spirit-detail-locker-consumption.component';
import { SpiritDetailLockerConsumptionImageUploadComponent } from './spirit-detail-locker-consumption-image-upload/spirit-detail-locker-consumption-image-upload.component';
import { SpiritDetailLockerConsumptionImageViewComponent } from './spirit-detail-locker-consumption-image-view/spirit-detail-locker-consumption-image-view.component';
import { DatePipe, JsonPipe } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SpiritDetailLockerDeleteComponent } from './spirit-detail-locker-delete/spirit-detail-locker-delete.component';
import { SpiritDetailLockerAddComponent } from './spirit-detail-locker-add/spirit-detail-locker-add.component';

const icons = [
  LockerIcon,
  ChevronDownIcon
]

const pipes = [
  DatePipe,
  JsonPipe
]

const materialModules = [
  MatIconModule,
  MatButtonModule
]

const components = [
  SpiritDetailLockerAddComponent
]

@Component({
  selector: 'app-spirit-detail-locker',
  standalone: true,
  imports: [TranslateModule, ...icons, ...pipes, ...materialModules, ...components],
  templateUrl: './spirit-detail-locker.component.html',
  styleUrls: ['./spirit-detail-locker.component.scss'],
})
export class SpiritDetailLockerComponent  implements OnInit {

  @Input() spirit: Spirit | null = null;
  @Input() lockerUser: any = null;
  @Input() menu: any;
  @Output() spiritAdded: any = new EventEmitter();

  api = inject(ApiService);
  apiUrl = environment.api;

  lockerSpirit: LockerSpirit | null = null;
  lockerExpanded: boolean = false;

  imageUploadClickCount: number = 0;
  imageUploadTimer: any = null;

  showAddToLockerQty: boolean = false;

  constructor(
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.api.getLockerSpirit(this.lockerUser.code, this.spirit!.uuid).subscribe(
      data => {
        if (data.success) {
          this.lockerSpirit = data.data.lockerSpirit;
          this.lockerSpirit!.consumptions = data.data.consumptions;
        }
      }
    );
  }

  openConsumptionDialog() {
    const dialogRef = this.dialog.open(SpiritDetailLockerConsumptionComponent, {
      maxWidth: '95vw',
      minWidth: '350px',
      panelClass: 'modal-no-padding'
    });

    dialogRef.componentInstance.lockerSpirit = this.lockerSpirit;
    dialogRef.componentInstance.lockerUser = this.lockerUser;

    dialogRef.afterClosed().subscribe((consumption) => {
      if (consumption) {
        const newQuantity = this.lockerSpirit!.quantity - consumption.quantity;
        this.lockerSpirit!.quantity = newQuantity;
        this.lockerSpirit!.consumptions.push(consumption);
      }
    });
  }

  openConsumptionHistoryDialog() {
    const dialogRef = this.dialog.open(SpiritDetailLockerConsumptionHistoryComponent, {
      maxWidth: '95vw',
      minWidth: '400px',
      panelClass: 'modal-no-padding'
    });

    dialogRef.componentInstance.lockerSpirit = this.lockerSpirit;
    dialogRef.componentInstance.lockerUser = this.lockerUser;

    dialogRef.afterClosed().subscribe(() => {
      const consumptions = dialogRef.componentInstance.consumptions;
      this.lockerSpirit!.consumptions = consumptions;
    });
  }

  openDeleteDialog() {
    const dialogRef = this.dialog.open(SpiritDetailLockerDeleteComponent, {
      maxWidth: '95vw',
      minWidth: '350px',
      panelClass: 'modal-no-padding'
    });

    dialogRef.componentInstance.lockerSpirit = this.lockerSpirit;
    dialogRef.componentInstance.lockerUser = this.lockerUser;

    dialogRef.afterClosed().subscribe((confirmation) => {
      if (confirmation && confirmation == 'deleted') {
        this.lockerExpanded = false;
        this.lockerSpirit = null;
      }
    });
  }

  openImageUploadDialog(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation(); 
    
    this.imageUploadClickCount ++;

    if (this.imageUploadTimer) {
      clearTimeout(this.imageUploadTimer);
    }

    this.imageUploadTimer = setTimeout(() => {
      this.imageUploadClickCount = 0;
    }, 500);

    if (this.imageUploadClickCount >= 3) {
    
      const dialogRef = this.dialog.open(SpiritDetailLockerConsumptionImageUploadComponent, {
        maxWidth: '95vw',
        minWidth: '350px',
        panelClass: 'modal-no-padding'
      });

      dialogRef.componentInstance.lockerSpirit = this.lockerSpirit;
      dialogRef.componentInstance.lockerUser = this.lockerUser;

      dialogRef.afterClosed().subscribe((path) => {
        if (path) {
          const consumption = this.lockerSpirit!.consumptions[this.lockerSpirit!.consumptions.length - 1];
          consumption.photoUrl = path;
          this.lockerSpirit!.consumptions[this.lockerSpirit!.consumptions.length - 1] = consumption;
        }
      });
    }
  }

  openImageDialog(url: string) {
    const dialogRef = this.dialog.open(SpiritDetailLockerConsumptionImageViewComponent, {
      maxWidth: '95vw',
      minWidth: '350px',
      panelClass: 'modal-no-padding'
    });

    dialogRef.componentInstance.url = url;
  }

  addToLocker() {
    this.showAddToLockerQty = false;
    this.spiritAdded.emit();
  }

}
